import React from 'react';
import {EventDetails} from './EventDetails';
import {EventHeaderTabMenu} from './EventHeaderTabMenu';
import {HeroImage} from './HeroImage';
import {SocialShare} from '../shared/SocialShare';
import {styles} from './styles';

export const EventHero = (props) => {

  const {
    erpEventId,
    eventId,
    eventName,
    masterEventId,
    searchQuery,
    excludeSearch,
    courses,
    selectedCourseData,
    isLive,
    tab,
    isMobile,
    master,
    starters,
    curatedMode,
    t
  } = props;

  const {
    masterName,
    eventType,
    ctliveId,
    affiliateRaceId,
    athlinksMasterId,
    isPublishedAthlinks,
    hasHeroImage,
  } = master;

  const buttonsProps = {
    master,
    isMobile
  };

  if (!isMobile) {
    return (
      <div style={{marginBottom: 20}}>
        <HeroImage
          heroHeight={300}
          isMobile={isMobile}
          type={eventType}
          ctliveEventId={affiliateRaceId}
          isPublished={isPublishedAthlinks}
          hasHeroImage={hasHeroImage}
        >
          <div style={styles.titleContainer}>
            <EventDetails
              eventId={eventId}
              master={master}
              isMobile={isMobile}
              starters={starters}
              searchQuery={searchQuery}
              excludeSearch={excludeSearch}
              color='white'
              type='eventHeader'
              ctliveId={ctliveId}
            />
          </div>
        </HeroImage>

        <div style={styles.tabRow}>
          <EventHeaderTabMenu
            tab={tab}
            event={master}
            courses={courses}
            isMobile={isMobile}
            eventName={eventName}
            starters={starters}
            masterId={athlinksMasterId}
            erpEventId={erpEventId}
            t={t}
          />
        </div>
      </div>
    );
  }
  else {
    return (
      <div style={{marginBottom: 20}}>
        <div style={{position:'relative'}}>
          <HeroImage
            heroHeight={300}
            isMobile={isMobile}
            type={eventType}
            ctliveEventId={affiliateRaceId}
            isPublished={isPublishedAthlinks}
            hasHeroImage={hasHeroImage}
          >
            <div style={styles.titleContainer}>
              <EventDetails
                eventName={masterName}
                eventId={eventId}
                master={master}
                masterEventId={masterEventId}
                isMobile={isMobile}
                starters={starters}
                isLive={isLive}
                searchQuery={searchQuery}
                excludeSearch={excludeSearch}
                color={'white'}
                type="eventHeader"
                ctliveId={ctliveId}
              />
            </div>
          </HeroImage>
          { !curatedMode &&
            <div style={styles.mobileSocialPosition(isLive)}>
              <SocialShare
                buttonsProps={buttonsProps}
                followButton={false}
                isMobile={isMobile}/>
            </div>
          }
        </div>

        <div style={styles.tabRow}>
          <EventHeaderTabMenu
            tab={tab}
            event={master}
            courses={courses}
            isMobile={isMobile}
            starters={starters}
            eventName={eventName}
            masterId={athlinksMasterId}
            selectedCourseData={selectedCourseData}
            t={t}
          />
        </div>
      </div>

    );
  }
};

EventHero.defaultProps = {
  excludeSearch: true,
  eventName: '',
  selectedCourseData: '',
  master: {},
  tab: '',
  courses: [],
};



/** WEBPACK FOOTER **
 ** ./components/heroImage/EventHero.js
 **/